import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useScoreboardState } from '@/hooks/useScoreboardState';
import { generateRawJson } from '@/api/rawJsonApi';

export default function RawJSONPage() {
  const { number } = useParams<{ number: string }>();
  
  const scoreboardState = useScoreboardState(number || "");

  useEffect(() => {
    // Generate clean JSON string
    const jsonString = generateRawJson(scoreboardState);
    
    // If this is a direct JSON request, serve pure JSON
    if (window.location.pathname.includes('/json/raw/kit/')) {
      // Set the content type header
      const meta = document.createElement('meta');
      meta.setAttribute('http-equiv', 'Content-Type');
      meta.setAttribute('content', 'application/json; charset=utf-8');
      
      // Clear any existing content and set up for JSON only
      document.head.innerHTML = '';
      document.head.appendChild(meta);
      document.body.innerHTML = '';
      
      // Create a text node with the JSON string
      const textNode = document.createTextNode(jsonString);
      document.body.appendChild(textNode);
      
      // Try to force the browser to treat this as a JSON download
      try {
        const blob = new Blob([jsonString], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        
        // Create an invisible iframe to load the JSON
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
      } catch (e) {
        console.error('Failed to create JSON blob:', e);
      }
    }
  }, [scoreboardState, number]);

  // For preview mode, show the JSON in a pre tag
  return (
    <div className="min-h-screen bg-black text-white p-4">
      <pre className="font-mono text-sm whitespace-pre-wrap">
        {generateRawJson(scoreboardState)}
      </pre>
    </div>
  );
}
